import React from 'react';

const DoorIcon = ({ size = 20, color = "currentColor" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Door frame */}
      <path 
        d="M4 20V4C4 3.44772 4.44772 3 5 3H12C12.5523 3 13 3.44772 13 4V20H4Z" 
        stroke={color} 
        strokeWidth="2" 
        fill="none"
      />
      
      {/* Door swing arc */}
      <path 
        d="M13 20C13 13.3726 7.62742 8 1 8" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeDasharray="2 2"
        fill="none"
      />
      
      {/* Door handle */}
      <circle 
        cx="10" 
        cy="12" 
        r="1" 
        fill={color}
      />
    </svg>
  );
};

export default DoorIcon; 